import {memo, useEffect, useRef} from 'react';
import NewsLetterTypeForm from './NewsLetterTypeForm.client';

const LoadTypeformScript = memo(({path}: {path: string}) => {
  const loaded = useRef(false); // This is to prevent the script from being loaded multiple times
  const isLoadFired = useRef(false); // This is to prevent the script from being loaded multiple times
  const loadScript = () => {
    if (!loaded.current) {
      loaded.current = true;
      const script = document.createElement('script');
      script.src = `//embed.typeform.com/next/embed.js?${Date.now()}`;
      document.body.appendChild(script);
    }
  };
  useEffect(() => {
    if (!isLoadFired.current) {
      isLoadFired.current = true;
      setTimeout(() => {
        loadScript();
      }, 1000);
    }
  }, []);

  return <NewsLetterTypeForm formKey="01HJ5XMCCSSE23814GX40TGBC4" />;
});

export default LoadTypeformScript;
